import React from "react";
import PanelLayout from "./PanelLayout";
import SidebarDoctor from "../scenes/doctor-global/SidebarDoctor";
import TopbarDoctor from "../scenes/doctor-global/TopbarDoctor";
import PanelThemeProvider from "../design-system/panel/PanelThemeProvider";

const renderDoctorSidebar = (sidebarProps) => <SidebarDoctor {...sidebarProps} />;
const renderDoctorTopbar = ({ menuOpen, setMenuOpen }) => (
  <TopbarDoctor menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
);

/** Doktor panel — PANEL light MUI (Select/TextField kontrastı) */
export default function DoctorLayout({ children, contentSx = {} }) {
  return (
    <PanelThemeProvider>
      <PanelLayout
        shellClassName="doctor-panel-shell"
        panelType="doctor"
        contentSx={contentSx}
        renderSidebar={renderDoctorSidebar}
        renderTopbar={renderDoctorTopbar}
      >
        {children}
      </PanelLayout>
    </PanelThemeProvider>
  );
}
